import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export function H3CellIcon(props: SvgIconProps): React.JSX.Element {
  return (
    <SvgIcon viewBox="0 0 78 88" {...props}>
      <path
        d="M39 -0.00012207L77.1051 21.9999V65.9999L39 87.9999L0.894882 65.9999V21.9999L39 -0.00012207Z"
        fill="currentColor"
      />
      <path
        d="M76.1807 22.5331V65.4657L39 86.9315L1.81934 65.4657V22.5331L39 1.06726L76.1807 22.5331Z"
        stroke="white"
        stroke-opacity="0.6"
        stroke-width="1.84874"
      />
    </SvgIcon>
  );
}
